import 'moment/dist/locale/zh-cn';
import './styles/global.less';
import './utils/sentry';

import { Modal } from 'ant-design-vue';
import { createApp } from 'vue';

import App from './App.vue';
import layouts from './layouts';
import router from './router';

const app = createApp(App);

app.use(router);
app.use(Modal);
app.use(layouts);

app.mount('#app');
